import React from 'react';
import { DarkGridHero } from '../components/hero/DarkGridHero';

const Home = () => {

  return (
    <DarkGridHero />
  );
};

export default Home;